import React from 'react'
import { View } from 'react-native'
import moment from 'moment'
import { Icon } from '@src/components/base/Icon'
import { Text } from '@src/components/base'
import { StyleService, useStyleSheet } from '@src/style/service'
import {
  VIDEO_SUGGESTED_CALL_CARD_TIME_FORMAT,
  VIDEO_CALL_CARD_TIME_FORMAT,
  VIDEO_CALL_CARD_DATE_FORMAT,
} from '@src/config/momentFormat'

interface CallDurationProps {
  duration: string | number
  meetingAt: string
  coachName?: string | null
  large?: boolean
  placeholder?: boolean
}

const CallDuration = ({
  large = false,
  placeholder = false,
  duration,
  meetingAt,
  coachName,
}: CallDurationProps) => {
  const styles = useStyleSheet(themedStyles)

  return (
    <View style={styles.container}>
      <View style={styles.detailItem}>
        <Icon style={[styles.icon, placeholder && styles.placeholder]} name="calendar-blank" />

        <Text
          type={large ? 'regular' : 'small'}
          style={[styles.time, placeholder && styles.placeholder]}
        >
          {moment(meetingAt).format(VIDEO_CALL_CARD_DATE_FORMAT)}
        </Text>
      </View>

      <View style={styles.detailItem}>
        <Icon style={[styles.icon, placeholder && styles.placeholder]} name="clock" />

        <Text
          type={large ? 'regular' : 'small'}
          style={[styles.time, placeholder && styles.placeholder]}
        >
          {coachName
            ? moment(meetingAt).format(VIDEO_SUGGESTED_CALL_CARD_TIME_FORMAT)
            : `${moment(meetingAt).format(VIDEO_CALL_CARD_TIME_FORMAT)} - ${moment(meetingAt)
                .add(duration, 'minutes')
                .format(VIDEO_CALL_CARD_TIME_FORMAT)}`}
        </Text>
      </View>

      <View style={styles.detailItem}>
        <Icon
          style={[styles.icon, placeholder && styles.placeholder]}
          name="hourglass-simple-medium"
        />

        <Text
          type={large ? 'regular' : 'small'}
          style={[styles.time, placeholder && styles.placeholder]}
        >
          {duration} min
        </Text>
      </View>
    </View>
  )
}

export default CallDuration

const themedStyles = StyleService.create({
  container: {
    display: 'flex',
    flexDirection: 'row',
    gap: 8,
  },
  detailItem: {
    flexDirection: 'row',
    alignItems: 'center',
    display: 'flex',
    gap: 4,
  },
  time: {
    color: 'theme.text.primary',
  },
  icon: {
    width: 16,
    height: 16,
  },
  placeholder: {
    color: 'theme.text.tertiary',
  },
})
